export default "__VITE_ASSET__Dp6hESY2__"